<mat-toolbar  class="breadcrumb-container">
    <nav aria-label="Breadcrumb navigation">
        <ol class="breadcrumb-list">
            <li *ngFor="let crumb of breadcrumbs; let last = last" class="breadcrumb-item">
                <a
                        mat-button
                        [routerLink]="crumb.url"
                        [attr.aria-current]="last ? 'page' : null"
                        [class.active]="last"
                >
<!--                    <mat-icon *ngIf="crumb.icon" class="crumb-icon">{{ crumb.icon }}</mat-icon>-->
                    {{ crumb.label }}
                </a>
                <mat-icon *ngIf="!last" aria-hidden="true" class="separator">chevron_left</mat-icon>
            </li>
        </ol>
    </nav>
</mat-toolbar>
